import Navbar from '../../components/Header';
import Footer from '../../components/Footer';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const PostCard = ({ post }: any) => {
  return (
    <a href={`/posts/${post.id}`} className="block">
      <div className="bg-neutral-800 rounded-3xl overflow-hidden h-full">
        <img 
          src={post.image} 
          alt={post.title} 
          className="w-full object-cover p-2 rounded-4xl" 
        />
        <div className="p-4">
          <h3 className="text-white text-3xl font-medium mb-2">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{post.title}</ReactMarkdown>
          </h3>
          {post.content && (
            <div className="markdown-content text-gray-300 mb-3">
              <ReactMarkdown remarkPlugins={[remarkGfm]}>{post.content}</ReactMarkdown>
            </div>
          )}
          <div className="flex items-center text-md">
            <img src={post.authorUrl} alt={post.author} className="h-6 w-6 rounded-full mr-1" />
            <span className="text-gray-300 ml-1">{post.author}</span>
            <span className="text-gray-500 mx-2">|</span>
            <span className="text-gray-300">{post.date}</span>
          </div>
        </div>
      </div>
    </a>
  );
};

const PostsPage = () => {
  const posts = [
    {
      id: 1,
      title: '# Octant Security Incident',
      author: 'Octant',
      authorUrl: '/octant.png',
      date: 'May 6, 2025',
      image: 'https://i.imgur.com/fRbZJhC.png',
      content: 'A detailed report on the timeline, causes, and resolution of the recent Octant security incident',
    }
  ];

  return (
    <div className="min-h-screen bg-neutral-950">
      <div className="max-w-6xl mx-auto bg-neutral-950">
        <Navbar />
        
    <div className="ml-6 mr-6 pt-24">
      <div className="grid grid-cols-1 gap-6 p-4 bg-neutral-900/60 rounded-3xl">
        {posts.map((post: any) => (
          <PostCard key={post.id} post={post} />
        ))}
      </div>
    </div>
        
        <Footer />
      </div>
    </div>
  );
};

export default PostsPage;